import React from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './App.jsx';
import './shell.css';

const boot = window.__EDL_DOCS__;

if (!boot) {
  document.getElementById('app').textContent = 'edl docs: missing boot data. Open this through `edl-docs dev` or a static build.';
} else {
  createRoot(document.getElementById('app')).render(<App boot={boot} />);
}
